import React, { useEffect, useState } from 'react';
import { Navigate, Routes, Route, useLocation, Link, useParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import { PageWithAds } from './components/AdBanner';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import CategoryJobsPage from './pages/CategoryJobsPage';
import JobDetailPage from './pages/JobDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DisclaimerPage from './pages/DisclaimerPage';
import SearchResultsPage from './pages/SearchResultsPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

function LegacyJobRouteRedirect() {
  const { jobId } = useParams();
  return <Navigate replace to={`/job/${jobId}`} />;
}

function AnalyticsLoader() {
  const [AnalyticsComponent, setAnalyticsComponent] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof navigator !== 'undefined' && /reactsnap/i.test(navigator.userAgent)) return;

    let mounted = true;

    import('@vercel/analytics/react')
      .then(({ Analytics }) => {
        if (mounted) {
          setAnalyticsComponent(() => Analytics);
        }
      })
      .catch(() => {});

    return () => {
      mounted = false;
    };
  }, []);

  return AnalyticsComponent ? <AnalyticsComponent /> : null;
}

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <main>
        <PageWithAds>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:categoryId" element={<CategoryJobsPage />} />
            <Route path="/job/:jobId" element={<JobDetailPage />} />
            <Route path="/job/:jobId/:categoryId" element={<LegacyJobRouteRedirect />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </PageWithAds>
      </main>
      <footer className="app-footer">
        <div className="footer-inner">
          <span className="footer-logo">Sarkari Naukri<span className="footer-logo-portal"> Rajasthan</span></span>
          <p className="footer-text">© 2026 SarkariNaukriRajasthan.com – Latest Government Jobs, Sarkari Result, Admit Cards & Answer Keys.</p>
          <div className="footer-links">
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
          <p className="footer-text" style={{fontSize:'0.75rem',marginTop:'4px',opacity:0.7}}>Rajasthan Govt Jobs | Central Govt Jobs | Bank Jobs | Railway Jobs | Defence Jobs | PSU Jobs</p>
        </div>
      </footer>
      <AnalyticsLoader />
    </div>
  );
}

export default App;
